export default "__VITE_ASSET__DmkA9wtc__"